<template>
    <div id="InsuranceCompanyCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-name" id="insuranceCompanyHeader" v-if="$route.params.id > 0">Update Insurance Company</span>
                    <span class="page-name" id="insuranceCompanyHeader" v-else>Add Insurance Company</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackInsuranceCompanyList"  >
                        <i class="fp-back"></i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content insurance-company-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="InsuranceCompanyForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Company Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Company Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="submit" id="CreateInsuranceCompanyBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateInsuranceCompany" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateInsuranceCompanyBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateInsuranceCompany" >
                                        <i class="fp-save"> </i>  Save
                                    </button> 
                                    <button type="submit" id="createAndContinueInsuranceCompanyBtn"  v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateInsuranceCompany(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i> Save and Continue
                                    </button> 
                                    <button type="submit" id="cancelInsuranceCompanyBtn" class="btn btn-tertiary" v-on:click.prevent="BackInsuranceCompanyList" >
                                        <i class="fp-close"> </i> Cancel
                                    </button> 
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "InsuranceCompanyCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Insurance company | " +process.env.COPYRIGHT_NAME : "Create Insurance Company | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    permissions: [],
    cantAccessPage: "",
    name: "",
    loading:false,
    name_error_msg: "",
    code:"",
    code_error_msg:""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_insurance_company') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.loadInsuranceCompany();
                
            }
        }, 100);
  },
  methods: {

    BackInsuranceCompanyList() {
      var self = this;
      self.$router.push("/insurancecompany/list");
    },

    CreateInsuranceCompany(flag) {
      var self = this;
      var error = false;

      self.name_error_msg = "";
      self.code_error_msg = "";

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
        error = true;
      }

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
        error = true;
      }
      
      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateInsuranceCompanyBtn").val("Updating ...");
                $("#CreateInsuranceCompanyBtn").prop("disabled", true);
                $("#cancelInsuranceCompanyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueInsuranceCompanyBtn").val("Saving ...");
                    $("#CreateInsuranceCompanyBtn").prop("disabled", true);
                    $("#createAndContinueInsuranceCompanyBtn").prop("disabled", true);
                    $("#cancelInsuranceCompanyBtn").prop("disabled",true);

                }else{

                    $("#CreateInsuranceCompanyBtn").val("Saving ...");
                    $("#CreateInsuranceCompanyBtn").prop("disabled", true);
                    $("#createAndContinueInsuranceCompanyBtn").prop("disabled", true);
                    $("#cancelInsuranceCompanyBtn").prop("disabled",true);
                }
               
            }

            var fields = $("#InsuranceCompanyForm").serializeArray();
            fields.push({name: "id", value: segments[3]});
            
            $.ajax({
                url: process.env.ROOT_API + "/insurancecompany/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateInsuranceCompanyBtn").val("Update");
                        $("#CreateInsuranceCompanyBtn").prop("disabled", false);
                        $("#cancelInsuranceCompanyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueInsuranceCompanyBtn").val("Save and Continue");
                            $("#CreateInsuranceCompanyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceCompanyBtn").prop("disabled", false);
                            $("#cancelInsuranceCompanyBtn").prop("disabled",false);

                        }else{

                            $("#CreateInsuranceCompanyBtn").val("Save");
                            $("#CreateInsuranceCompanyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceCompanyBtn").prop("disabled", false);
                            $("#cancelInsuranceCompanyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#InsuranceCompanyForm").trigger("reset");
                            self.name ="";
                            self.code = "";
                    
                        }else{
                            self.$router.push("/insurancecompany/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateInsuranceCompanyBtn").val("Update");
                        $("#CreateInsuranceCompanyBtn").prop("disabled", false);
                        $("#cancelInsuranceCompanyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#InsuranceCompanyForm").trigger("reset");
                            

                            $("#createAndContinueInsuranceCompanyBtn").val("Save and Continue");
                            $("#CreateInsuranceCompanyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceCompanyBtn").prop("disabled", false);
                            $("#cancelInsuranceCompanyBtn").prop("disabled",false);

                        }else{

                            $("#CreateInsuranceCompanyBtn").val("Save");
                            $("#CreateInsuranceCompanyBtn").prop("disabled", false);
                            $("#createAndContinueInsuranceCompanyBtn").prop("disabled", false);
                            $("#cancelInsuranceCompanyBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'insurance-company-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
     
    },

    loadInsuranceCompany() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/insurancecompany/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                    self.name = data.content.company_name;
                    self.code = data.content.company_code;
                     
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'insurance-company-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/InsuranceCompanyCreate.vue